export const readLicensesActiveApiParams = {
  method: 'GET',
  endpoint: 'stripe'
};

export const readLicensesApiParams = {
  method: 'GET',
  endpoint: 'stripeProducts'
};
